<script setup>
import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({})

// I18n
const { t, tm } = useI18n()

// Stores

// Variables

// Event Handlers
onMounted(async () => {
})

watch(() => null, () => {
})

// Functions

</script>

<template>
  <div class="px-8">
    <div class="flex gap-8 flex-col md:flex-row md:items-center md:justify-between lg:justify-start content-start lg:items-start">
      <img src="/src/assets/icons/check_circle_24dp_FILL1_wght400_GRAD0_opsz24.svg" class="h-[60px]" alt="card icon" />
      <div class="w-full lg:w-2/3">
        <h2 class="text-2xl mb-2 font-semibold">{{ t('request_a_quote.success_section.title') }}</h2>
        <p class="text-xl">{{ t('request_a_quote.success_section.subtext[0]') }}</p>
        <p class="text-xl">{{ t('request_a_quote.success_section.subtext[1]') }}</p>
        <p class="text-xl">{{ t('request_a_quote.success_section.subtext[2]') }}</p>
        <p class="text-xl" v-html="tm('request_a_quote.success_section.subtext[3]')"></p> <!-- Loading HTML for the bold text -->
        <p class="text-xl">{{ t('request_a_quote.success_section.subtext[4]') }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
